// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ScrubberUI__ScrubberUI___10kRv{background-color:#f5f5f5;border:1px solid #cacaca;cursor:pointer;display:flex;flex-direction:column;position:absolute;z-index:9}.ScrubberUI__ScrubberUIVertical___SwxZ0{border-radius:14px 0 0 14px;height:26px;right:0;width:42px;z-index:9}.ScrubberUI__ScrubberUIHorizontal___Fxy75{border-radius:14px 14px 0 0;bottom:0;height:42px;width:26px}.ScrubberUI__ScrubberPageNumVertical___2unkB{margin-left:15px;margin-top:4px}.ScrubberUI__ScrubberPageNumHorizontal___s2C3o{margin-right:1px;margin-top:15px;writing-mode:vertical-rl}", ""]);
// Exports
exports.locals = {
	"ScrubberUI": "ScrubberUI__ScrubberUI___10kRv",
	"ScrubberUIVertical": "ScrubberUI__ScrubberUIVertical___SwxZ0",
	"ScrubberUIHorizontal": "ScrubberUI__ScrubberUIHorizontal___Fxy75",
	"ScrubberPageNumVertical": "ScrubberUI__ScrubberPageNumVertical___2unkB",
	"ScrubberPageNumHorizontal": "ScrubberUI__ScrubberPageNumHorizontal___s2C3o"
};
module.exports = exports;
